import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Alginment, EMPTY_STRING, LoadingMessages, MAX_RECORD } from "src/app/common/Const";
import { ME000002, MI100001, MI200003, MQ200010 } from "src/app/common/const-message-id";
import { GC_D0045_INTERSTORE, GC_D0046_CANCELLED, GC_D0046_VALID, GC_D2016_CORR_SLIP, GC_D2016_NORMAL_SLIP, GC_D2083_OUT_APPROVED } from "src/app/common/ConstCcd";
import { GC_H0045_INTERSTORE_SLIP_TYPE, GC_H0046_SLIP_CANCEL_FLAG, GC_H2016_SLIP_CORR_TYPE, GC_H2083_APPL_STATUS_IST } from "src/app/common/ConstCcdDef";
import { TableColumnDef } from "src/app/common/table-column-def";
import { Spmt10291ConfirmDialogComponent } from "src/app/dialog/spmt10291-confirm-dialog/spmt10291-confirm-dialog.component";
import { Spmt10291DetailDialogComponent } from "src/app/dialog/spmt10291-detail-dialog/spmt10291-detail-dialog.component";
import { Req } from "src/app/request/req";
import { ReqAccess } from "src/app/request/req-access";
import { ReqGetStoreList } from "src/app/request/req-get-store-list";
import { Spmt10291DetailCommentDto } from "src/app/request/req-spmt10291-confirm";
import { ReqSpmt10291Search } from "src/app/request/req-spmt10291-search";
import { ReqTmt003AllStoreSearch } from "src/app/request/req-tmt003-all-store-search";
import { DropdownListOfUserDto } from "src/app/response/rsp-get-dropdown-list-of-user";
import { GetStoreListDto } from "src/app/response/rsp-get-store-list";
import { Spmt10291SearchRowDto } from "src/app/response/rsp-spmt10291-search";
import { Tmt003StoreDto } from "src/app/response/rsp-tmt003-all-store-search";
import { KbnSearchDto } from "src/app/response/rsp-tmt050-all-kbn-search";
import { CommonService } from "src/app/service/common.service";
import { HttpBasicService } from "src/app/service/http-basic.service";
import { MessageService } from "src/app/service/message.service";
import { ValidateService } from "src/app/service/validate.service";

export enum ColumnIds {
  Checkbox = "checkbox",
  SlipNo = "slipNo",
  OutStoreCd = "outStoreCd",
  OutStoreNm = "outStoreNm",
  SlipTypeNm = "slipTypeNm",
  InDate = "inDate",
  ReqStatusNm = "reqStatusNm",
  RedBlackNm = "redBlackNm",
  SlipCancelNm = "slipCancelNm",
  InStockQtyTotal = "inStockQtyTotal",
  InCostAmtExcTotal = "inCostAmtExcTotal",
  InSellPriceAmtExcTotal = "inSellPriceAmtExcTotal",
  SlipCreateDate = "slipCreateDate",
  OutSlipApproveDate = "outSlipApproveDate",
  InSlipApproveDate = "inSlipApproveDate",
  SlipChangeDate = "slipChangeDate",
  SlipCancelDate = "slipCancelDate",
  OutRequesterNm = "outRequesterNm",
  OutApproverNm = "outApproverNm",
  InApproverNm = "inApproverNm",
  OutSlipComment = "outSlipComment",
  OutSlipApproverComment = "outSlipApproverComment",
  InSlipApproverComment = "inSlipApproverComment",
}

export enum ColumnHeaders {
  Checkbox = "選択",
  SlipNo = "伝票番号",
  OutStoreCd = "出庫店コード",
  OutStoreNm = "出庫店名称",
  SlipTypeNm = "店間移動伝票区分",
  InDate = "入庫日",
  ReqStatusNm = "申請状態",
  RedBlackNm = "赤黒区分",
  SlipCancelNm = "伝票取消フラグ",
  InStockQtyTotal = "入庫数量合計",
  InCostAmtExcTotal = "入庫原価金額合計(抜)",
  InSellPriceAmtExcTotal = "入庫売価金額合計(抜)",
  SlipCreateDate = "伝票登録日",
  OutSlipApproveDate = "伝票承認日(出庫)",
  InSlipApproveDate = "伝票承認日(入庫)",
  SlipChangeDate = "伝票訂正日",
  SlipCancelDate = "伝票取消日",
  OutRequesterNm = "出庫申請者",
  OutApproverNm = "出庫承認者",
  InApproverNm = "入庫承認者",
  OutSlipComment = "出庫申請者コメント",
  OutSlipApproverComment = "出庫承認者コメント",
  InSlipApproverComment = "入庫承認者コメント",
}

interface TableRow extends Spmt10291SearchRowDto {
  form: {
    checkFormCtrl: FormControl;
    inDateForm: FormControl;
  };
  details: Spmt10291DetailCommentDto[];
  isDisableRow: boolean;
}

class Constant {
  public static readonly SLIP_NO_CTRL = "slipNo";
  public static readonly OUT_STORE_CD_CTRL = "outStoreCd";
  public static readonly IN_STORE_CD_CTRL = "inStoreCd";
  public static readonly SLIP_CREATE_DATE_FROM_CTRL = "slipCreateDateFrom";
  public static readonly SLIP_CREATE_DATE_TO_CTRL = "slipCreateDateTo";
  public static readonly REQ_STATUS_CTRL = "reqStatus";
  public static readonly OUT_REQUESTER_CD_CTRL = "outRequesterCd";
  public static readonly OUT_APPROVER_CD_CTRL = "outApproverCd";
  public static readonly IN_APPROVER_CD_CTRL = "inApproverCd";
  public static readonly SLIP_CANCEL_FLG_CTRL = "slipCancelFlg";
  public static readonly RED_BLACK_FLG_CTRL = "redBlackFlg";
  public static readonly SLIP_TYPE_CTRL = "slipType";
}

@Component({
  selector: "app-spmt10291",
  templateUrl: "./spmt10291.component.html",
  styleUrls: ["./spmt10291.component.css"],
})
export class Spmt10291Component implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  access: ReqAccess = {
    ...this.commonService.loginUser,
  };

  dataSource: MatTableDataSource<TableRow> = new MatTableDataSource<TableRow>([]);
  checkAllFormCtrl: FormControl = new FormControl(false);
  storeSearchConditions: any = {};
  itemRecordCount: number = 0;

  columnIds: string[] = [
    ColumnIds.Checkbox,
    ColumnIds.SlipNo,
    ColumnIds.OutStoreCd,
    ColumnIds.OutStoreNm,
    ColumnIds.SlipTypeNm,
    ColumnIds.InDate,
    ColumnIds.ReqStatusNm,
    ColumnIds.RedBlackNm,
    ColumnIds.SlipCancelNm,
    ColumnIds.InStockQtyTotal,
    ColumnIds.InCostAmtExcTotal,
    ColumnIds.InSellPriceAmtExcTotal,
    ColumnIds.SlipCreateDate,
    ColumnIds.OutSlipApproveDate,
    ColumnIds.InSlipApproveDate,
    ColumnIds.SlipChangeDate,
    ColumnIds.SlipCancelDate,
    ColumnIds.OutRequesterNm,
    ColumnIds.OutApproverNm,
    ColumnIds.InApproverNm,
    ColumnIds.OutSlipComment,
    ColumnIds.OutSlipApproverComment,
    ColumnIds.InSlipApproverComment,
  ];

  columnDefs: TableColumnDef[] = [
    { columnId: ColumnIds.Checkbox, header: ColumnHeaders.Checkbox, width: 40, align: Alginment.Center, checkbox: true },
    { columnId: ColumnIds.SlipNo, header: ColumnHeaders.SlipNo, width: 80, align: Alginment.Left, editable: true },
    { columnId: ColumnIds.OutStoreCd, header: ColumnHeaders.OutStoreCd, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.OutStoreNm, header: ColumnHeaders.OutStoreNm, width: 100, align: Alginment.Left },
    { columnId: ColumnIds.SlipTypeNm, header: ColumnHeaders.SlipTypeNm, width: 105, align: Alginment.Left },
    { columnId: ColumnIds.InDate, header: ColumnHeaders.InDate, width: 130, align: Alginment.Left, isDatePicker: true },
    { columnId: ColumnIds.ReqStatusNm, header: ColumnHeaders.ReqStatusNm, width: 85, align: Alginment.Left },
    { columnId: ColumnIds.RedBlackNm, header: ColumnHeaders.RedBlackNm, width: 60, align: Alginment.Left },
    { columnId: ColumnIds.SlipCancelNm, header: ColumnHeaders.SlipCancelNm, width: 95, align: Alginment.Left },
    { columnId: ColumnIds.InStockQtyTotal, header: ColumnHeaders.InStockQtyTotal, width: 80, align: Alginment.Right, numberPipe: "1.0-0" },
    { columnId: ColumnIds.InCostAmtExcTotal, header: ColumnHeaders.InCostAmtExcTotal, width: 135, align: Alginment.Right, numberPipe: "1.0-0" },
    { columnId: ColumnIds.InSellPriceAmtExcTotal, header: ColumnHeaders.InSellPriceAmtExcTotal, width: 135, align: Alginment.Right, numberPipe: "1.0-0" },
    { columnId: ColumnIds.SlipCreateDate, header: ColumnHeaders.SlipCreateDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.OutSlipApproveDate, header: ColumnHeaders.OutSlipApproveDate, width: 110, align: Alginment.Left },
    { columnId: ColumnIds.InSlipApproveDate, header: ColumnHeaders.InSlipApproveDate, width: 110, align: Alginment.Left },
    { columnId: ColumnIds.SlipChangeDate, header: ColumnHeaders.SlipChangeDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.SlipCancelDate, header: ColumnHeaders.SlipCancelDate, width: 80, align: Alginment.Left },
    { columnId: ColumnIds.OutRequesterNm, header: ColumnHeaders.OutRequesterNm, width: 100, align: Alginment.Left },
    { columnId: ColumnIds.OutApproverNm, header: ColumnHeaders.OutApproverNm, width: 100, align: Alginment.Left },
    { columnId: ColumnIds.InApproverNm, header: ColumnHeaders.InApproverNm, width: 100, align: Alginment.Left },
    { columnId: ColumnIds.OutSlipComment, header: ColumnHeaders.OutSlipComment, width: 180, align: Alginment.Left },
    { columnId: ColumnIds.OutSlipApproverComment, header: ColumnHeaders.OutSlipApproverComment, width: 180, align: Alginment.Left },
    { columnId: ColumnIds.InSlipApproverComment, header: ColumnHeaders.InSlipApproverComment, width: 180, align: Alginment.Left },
  ];

  storeList: GetStoreListDto[] = [];
  allStoreList: Tmt003StoreDto[] = [];
  userList: DropdownListOfUserDto[] = [];
  reqStatusList: KbnSearchDto[] = [];
  slipCancelList: KbnSearchDto[] = [];
  redBlackList: KbnSearchDto[] = [];
  slipTypeList: KbnSearchDto[] = [];

  itemTableWidth: any;
  tableHeight: number = 350;
  searchCondition: FormGroup;
  constructor(public commonService: CommonService, public httpBasic: HttpBasicService, private readonly message: MessageService, private readonly fb: FormBuilder) {
    this.searchCondition = this.fb.group({
      slipNo: [EMPTY_STRING],
      outStoreCd: [EMPTY_STRING],
      inStoreCd: [EMPTY_STRING, Validators.required],
      slipCreateDateFrom: [EMPTY_STRING],
      slipCreateDateTo: [EMPTY_STRING],
      reqStatus: fb.array([], [ValidateService.atLeastOneCheckedValidator()]),
      outRequesterCd: [EMPTY_STRING],
      outApproverCd: [EMPTY_STRING],
      inApproverCd: [EMPTY_STRING],
      slipCancelFlg: [GC_D0046_VALID],
      redBlackFlg: [GC_D2016_NORMAL_SLIP],
      slipType: [GC_D0045_INTERSTORE],
    });
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.commonService.pageTitle = this.commonService.pageMenuName;
    this.fnGetAccessInfo();
    this.calcTableWidth();
  }

  initScreen() {
    this.getUserLists();
    this.getStoreList();
    this.getAllStoreList()
    this.getKbnList(() => {
      const reqStatus: FormArray = this.searchCondition.get(Constant.REQ_STATUS_CTRL) as FormArray;
      this.reqStatusList.forEach((item) => {
        const isTrue = item.kbn === GC_D2083_OUT_APPROVED;
        reqStatus.push(new FormControl(isTrue));
      });
      this.checkRedirectAlert();
    });
  }

  private getAllStoreList() {
    let request: ReqTmt003AllStoreSearch = {
      access: this.access,
    };

    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    this.httpBasic.tmt003AllStoreSearch(request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.allStoreList = res.rows;
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  getKbnList(callBack: () => void) {
    const rcdKbns = [GC_H2083_APPL_STATUS_IST, GC_H2016_SLIP_CORR_TYPE, GC_H0046_SLIP_CANCEL_FLAG, GC_H0045_INTERSTORE_SLIP_TYPE];
    const request = {
      access: this.access,
      rcdKbns,
    };
    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    return this.httpBasic.tmt050AllKbnSearch(request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.redBlackList = res.rows.filter((row) => row.rcdKbn === GC_H2016_SLIP_CORR_TYPE);
        this.reqStatusList = res.rows.filter((row) => row.rcdKbn === GC_H2083_APPL_STATUS_IST);
        this.slipCancelList = res.rows.filter((row) => row.rcdKbn === GC_H0046_SLIP_CANCEL_FLAG);
        this.slipTypeList = res.rows.filter((row) => row.rcdKbn === GC_H0045_INTERSTORE_SLIP_TYPE);
        callBack();
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  private getStoreList() {
    let request: ReqGetStoreList = {
      access: this.access,
      storeCd: EMPTY_STRING,
      userId: EMPTY_STRING,
      cmpyCd: this.access.cmpnyCd,
      sysModeCd: this.access.sysModeCd,
    };

    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    this.httpBasic.getStoreList(request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.storeList = res.rows;
        this.searchCondition.get(Constant.IN_STORE_CD_CTRL).setValue(this.access.storeCd);
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  getUserLists() {
    let request: Req = {
      access: this.commonService.loginUser,
    };
    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    this.httpBasic.generalRequest("GetUserList", request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.userList = res.rows;
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  private checkRedirectAlert() {
    const state = history.state;
    const reqStatus = state?.reqStatus;
    const slipCancelFlg = state?.slipCancelFlg;
    const storeCd = state?.storeCd;
    if (reqStatus || slipCancelFlg || storeCd) {
      if (reqStatus != undefined) {
        const reqStatuses = reqStatus.split(',');
        const reqStatusFormArr = this.searchCondition.get(Constant.REQ_STATUS_CTRL) as FormArray;
        reqStatusFormArr.controls.forEach((control: FormControl, index: number) => {
          const isChecked = reqStatuses.includes(this.reqStatusList[index]?.kbn);
          control.setValue(isChecked);
        });
      }
      if (slipCancelFlg) {
        this.searchCondition.get(Constant.SLIP_CANCEL_FLG_CTRL).setValue(slipCancelFlg);
      }
      if (storeCd) {
        this.searchCondition.get(Constant.IN_STORE_CD_CTRL).setValue(storeCd);
      }
      this.btnSearchClick();
    }
  }

  btnClearClick() {
    if (this.dataSource.data.length > 0) {
      this.commonService.openYesNoDialog(this.commonService.pageTitle, this.message.message[MQ200010]).subscribe((result) => {
        if (result) {
          this.fnClear();
        }
      });
      return;
    }
    this.fnClear();
  }

  private fnClear() {
    this.searchCondition.reset();
    this.checkAllFormCtrl.setValue(false);
    this.searchCondition.get(Constant.IN_STORE_CD_CTRL).setValue(this.access.storeCd);
    this.dataSource.data = [];
    this.searchCondition.get(Constant.SLIP_CANCEL_FLG_CTRL).setValue(GC_D0046_VALID);
    this.searchCondition.get(Constant.SLIP_TYPE_CTRL).setValue(GC_D0045_INTERSTORE);
    this.searchCondition.get(Constant.RED_BLACK_FLG_CTRL).setValue(GC_D2016_NORMAL_SLIP);
    const reqStatus: FormArray = this.searchCondition.get(Constant.REQ_STATUS_CTRL) as FormArray;
    this.reqStatusList.forEach((item, i) => {
      const isTrue = item.kbn === GC_D2083_OUT_APPROVED;
      reqStatus.controls[i].setValue(isTrue);
    });
  }

  /**
   * calcTableWidth
   */
  calcTableWidth() {
    this.itemTableWidth = { width: "100%" };
  }

  btnSearchClick() {
    if (!this.searchCondition.valid) {
      return;
    }
    let reqStatus: string[] = [];
    const reqStatusFormArray = this.searchCondition.get(Constant.REQ_STATUS_CTRL) as FormArray;
    this.reqStatusList.forEach((item, i) => {
      if (reqStatusFormArray.value[i]) {
        reqStatus.push(item.kbn);
      }
    });
    this.storeSearchConditions = {
      slipNo: this.searchCondition.get(Constant.SLIP_NO_CTRL).value,
      outStoreCd: this.searchCondition.get(Constant.OUT_STORE_CD_CTRL).value,
      inStoreCd: this.searchCondition.get(Constant.IN_STORE_CD_CTRL).value,
      slipCreateDateFrom: this.commonService.dateToString(this.searchCondition.get(Constant.SLIP_CREATE_DATE_FROM_CTRL).value),
      slipCreateDateTo: this.commonService.dateToString(this.searchCondition.get(Constant.SLIP_CREATE_DATE_TO_CTRL).value),
      reqStatus: reqStatus,
      outRequesterCd: this.searchCondition.get(Constant.OUT_REQUESTER_CD_CTRL).value,
      outApproverCd: this.searchCondition.get(Constant.OUT_APPROVER_CD_CTRL).value,
      inApproverCd: this.searchCondition.get(Constant.IN_APPROVER_CD_CTRL).value,
      slipCancelFlg: this.searchCondition.get(Constant.SLIP_CANCEL_FLG_CTRL).value,
      redBlackFlg: this.searchCondition.get(Constant.RED_BLACK_FLG_CTRL).value,
      slipType: this.searchCondition.get(Constant.SLIP_TYPE_CTRL).value,
    };
    this.fnSearch();
  }

  private fnSearch() {
    this.checkAllFormCtrl.setValue(false);
    const req: ReqSpmt10291Search = {
      access: this.access,
      ...this.storeSearchConditions,
      pageInfo: { pageNum: 0, dispNum: MAX_RECORD + 1 },
    };
    this.httpBasic.beforeRequestStart(LoadingMessages.Searching);
    this.httpBasic.spmt10291Search(req).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        if (res.rows.length === 0) {
          this.commonService.openNotificationDialog(this.commonService.pageTitle, this.message.message[MI100001]);
          this.dataSource.data = [];
          return;
        }
        if (res.rows.length > MAX_RECORD) {
          this.commonService.openNotificationDialog(this.commonService.pageTitle, this.message.message[MI200003].replace("%1", MAX_RECORD).replace("%1", MAX_RECORD));
        }
        this.dataSource.data = res.rows.slice(0, MAX_RECORD).map((item) => ({
          ...item,
          isDisableRow: this.isRowDisabled(item),
          form: {
            checkFormCtrl: new FormControl({ value: false, disabled: this.isRowDisabled(item) }),
            inDateForm: new FormControl({ value: item.inDate ? new Date(item.inDate) : EMPTY_STRING, disabled: this.isRowDisabled(item) }),
          },
          details: [],
        }));
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  isRowDisabled(row: Spmt10291SearchRowDto | TableRow): boolean {
    return row.slipCancelFlg === GC_D0046_CANCELLED || row.redBlackFlg === GC_D2016_CORR_SLIP || row.reqStatus !== GC_D2083_OUT_APPROVED;
  }

  onClickLink(row: TableRow) {
    const dialogRef = this.commonService.dialog.open(Spmt10291DetailDialogComponent, {
      autoFocus: false,
      data: {
        ...row,
        access: this.access,
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        row.details = data;
      }
    });
  }

  fnGetAccessInfo() {
    let req: Req = {
      access: this.access,
    };
    this.httpBasic.beforeRequestStart();
    this.httpBasic.getUserInfo(req).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        if (res.rows.length > 0) {
          this.access.cmpnyCd = res.rows[0].mainCmpnyCd;
          this.access.storeCd = res.rows[0].mainStoreCd;
          this.access.sysModeCd = res.rows[0].sysModeCd;
          this.access.lang = res.rows[0].mainLang;
          this.searchCondition.get(Constant.IN_STORE_CD_CTRL).setValue(this.access.storeCd);
          this.initScreen();
        }
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  onChangeRowCheck() {
    this.checkAllFormCtrl.setValue(this.dataSource.data.filter((item) => !item.isDisableRow).every((item) => item.form.checkFormCtrl.value));
  }

  checkAll($event: any): void {
    this.dataSource.data.forEach((item) => {
      if (!item.isDisableRow) item.form.checkFormCtrl.setValue($event.checked);
    });
  }

  get GC_D2016_CORR_SLIP(): string {
    return GC_D2016_CORR_SLIP;
  }
  isDisableBtnConfirm() {
    return this.dataSource.data.length === 0 || this.dataSource.data.every((item) => !item.form.checkFormCtrl.value);
  }

  btnConfirmClick(): void {
    for (let i = 0; i < this.dataSource.data.length; i++) {
      if (this.dataSource.data[i].form.checkFormCtrl.value && !this.dataSource.data[i].form.inDateForm.value) {
        const message = `レコード番号: ${i + 1}<br/>` + this.message.message[ME000002]?.replace("%1", "入庫日");
        this.commonService.openErrorDialog(this.commonService.pageTitle, message);
        return;
      }
    }
    const dialogRef = this.commonService.dialog.open(Spmt10291ConfirmDialogComponent, {
      autoFocus: false,
      data: {
        rows: this.dataSource.data
          .filter((item) => item.form.checkFormCtrl.value)
          .map((item) => {
            return {
              ...item,
              inDate: this.commonService.dateToString(item.form.inDateForm.value),
              form: undefined,
            };
          }),
        access: this.access,
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.fnSearch();
      }
    });
  }

  isCheckboxAllDisabled() {
    return this.dataSource.data.length === 0 || this.dataSource.data.every((item) => item.isDisableRow);
  }
}
